<template>
  <div
    :id="'hikplayer' + hikId"
    style="
      width: 100%;
      height: 100%;
      background-color: #000000;
      margin: 0 auto;
      position: relative;
    "
  ></div>
</template>

<script>
const IS_MOVE_DEVICE = document.body.clientWidth < 992; // 是否移动设备
const MSE_IS_SUPPORT = !!window.MediaSource; // 是否支持mse

export default {
  props: {
    url: '',
    hikId: ''
  },
  data() {
    return {
      player: undefined,
      mseSupport: MSE_IS_SUPPORT,
      tabActive: MSE_IS_SUPPORT ? 'mse' : 'decoder'
    };
  },
  mounted() {
    this.$el.style.setProperty('display', 'block');
    this.init();
    this.createPlayer();
  },
  destroyed() {
    this.stopPlay();
  },
  computed: {
    mode: function () {
      return this.tabActive === 'mse' ? 0 : 1;
    }
  },
  watch: {
    url(newVal) {
      this.realplay();
    }
  },
  methods: {
    resize() {
      this.player.JS_Resize();
      this.clearBorder();
    },
    init() {
      const that = this;
      // 设置播放容器的宽高并监听窗口大小变化
      window.addEventListener('resize', () => {
        that.resize();
      });
    },
    createPlayer() {
      if (this.player) return;
      const that = this;
      this.player = new window.JSPlugin({
        szId: 'hikplayer' + this.hikId,
        szBasePath: './static/js/h5player',
        iMaxSplit: 1,
        iCurrentSplit: 1,
        openDebug: true
        // oStyle: {
        //   borderSelect: IS_MOVE_DEVICE ? '#000' : '#FFCC00'
        // }
      });

      // 事件回调绑定
      this.player.JS_SetWindowControlCallback({
        windowEventSelect: function (iWndIndex) {
          //插件选中窗口回调
          console.log('windowSelect callback: ', iWndIndex);
          that.clearBorder();
        },
        pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {
          //插件错误回调
          console.log('pluginError callback: ', iWndIndex, iErrorCode, oError);
        },
        windowEventOver: function (iWndIndex) {
          //鼠标移过回调
          //   console.log(iWndIndex);
        },
        windowEventOut: function (iWndIndex) {
          //鼠标移出回调
          //   console.log(iWndIndex);
        },
        windowEventUp: function (iWndIndex) {
          //鼠标mouseup事件回调
          //   console.log(iWndIndex);
        },
        windowFullCcreenChange: function (bFull) {
          //全屏切换回调
          console.log('fullScreen callback: ', bFull);
        },
        firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {
          //首帧显示回调
          console.log(
            'firstFrame loaded callback: ',
            iWndIndex,
            iWidth,
            iHeight
          );
        },
        performanceLack: function () {
          //性能不足回调
          console.log('performanceLack callback: ');
        }
      });
      this.clearBorder();
      setTimeout(() => {
        this.realplay();
      }, 500);
    },
    clearBorder() {
      setTimeout(() => {
        const parentDiv = document.getElementById('hikplayer' + this.hikId);
        var playerDiv = parentDiv.querySelector('div[id="player-container-0"]');
        playerDiv.style.border = 'none'; // 设置边框为无
      }, 10);
    },
    realplay() {
      let { player, mode } = this,
        index = player.currentWindowIndex,
        playURL = this.url;
      console.log('hik realplay url: ', playURL);
      player.JS_Play(playURL, { playURL, mode }, index).then(
        () => {
          console.log('realplay success');
        },
        (e) => {
          console.error(e);
        }
      );
    },
    stopPlay() {
      const that = this;
      this.player.JS_Stop().then(
        () => {
          //   this.playback.rate = 0;
          console.log('stop realplay success');
        },
        (e) => {
          console.error(e);
          that.$message.error(e);
        }
      );
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/hikPlayer.vue